import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../context/GlobalContext';
import '../styles/HamburgerMenu.css';

const HamburgerMenu = () => {
  const { t } = useTranslation();
  const { navMenuItems } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e, route) => {
    e.preventDefault();
    setIsOpen(false);
    
    if (route === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (route.startsWith('#')) {
      const elementId = route.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const getTranslationKey = (label) => {
    if (label === 'Home') return 'home';
    if (label === 'Pricing Plans') return 'pricing';
    if (label === 'Contact Us') return 'contact';
    return 'home';
  };

  return (
    <>
      <button 
        className={`hamburger-btn ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {isOpen && (
        <>
          <div className="hamburger-overlay" onClick={() => setIsOpen(false)}></div>
          <nav className="hamburger-menu">
            <ul className="hamburger-menu-list">
              {navMenuItems.map((item) => (
                <li key={item.id}>
                  <a 
                    href={item.route} 
                    className="hamburger-link"
                    onClick={(e) => handleClick(e, item.route)}
                  >
                    {t(`nav.${getTranslationKey(item.label)}`)}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </>
      )}
    </>
  );
};

export default HamburgerMenu;

